module.exports = "<app-subsidiary-company-agent-list></app-subsidiary-company-agent-list>"